import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const HeaderOne = createSvgIcon(
  <>
    <path d="M6.53333 14H10.2667V11.2H6.53333V14ZM1.86667 0V2.8H6.53333V5.6H10.2667V2.8H14.9333V0H1.86667ZM0 9.33333H16.8V7.46667H0V9.33333Z" />
  </>,
  "HeaderOne"
);

export default HeaderOne;
